import { render, staticRenderFns } from "./FarmSidebar.vue?vue&type=template&id=ae10b622&lang=pug&"
import script from "./FarmSidebar.vue?vue&type=script&lang=js&"
export * from "./FarmSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports